import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { authApi } from "./session";

/** Ends the session and drops every cached query, so nothing from this account stays in memory. */
export function useSignOut() {
  const client = useQueryClient();
  const navigate = useNavigate();
  return async () => {
    try {
      await authApi.signOut();
    } finally {
      client.clear();
      navigate("/login", { replace: true });
    }
  };
}
